import React, { useState } from 'react';
import PropTypes, { object } from 'prop-types';
import cn from 'classnames';

import {
  Table,
  SortingIcon,
  TableFilterFromToOld,
  DateTime,
  EmptyState,
  ContactPerson,
  Loading
} from 'components/common/Elements/Elements';

import { moneyFormater } from 'utils/common';
import { tableConf } from '../helpers/configurates';

import classes from './ArrActivityTable.module.scss';

const ArrActivityTable = ({
  tableData = [],
  handleSortable,
  direction,
  fieldName,
  loader,
  ...other
}) => {
  const [row, setRow] = useState('');

  const mouseEnter = e => {
    setRow(e.currentTarget.getAttribute('r'));
  };
  const mouseLeave = () => {
    setRow('');
  };

  return (
    <>
      <Table>
        <Table.Header>
          <Table.Row withBorder={false}>
            {tableConf.map(({ isSortable, field, title, fromToGroup }, ind) => (
              <Table.HeaderCell
                key={field}
                className={classes.headerCell}
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                r={`r${ind}`}
                title={title}
              >
                {fromToGroup && (
                  <TableFilterFromToOld {...other} field={field} />
                )}
                {isSortable && (
                  <SortingIcon
                    direction={direction}
                    field={field}
                    fieldName={fieldName}
                    onClick={handleSortable(field)}
                  />
                )}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>
        {loader || tableData.length === 0 ? (
          <Table.Body></Table.Body>
        ) : (
          <Table.Body>
            {tableData.map((company, ind) => (
              <Table.Row key={`${company.createdDate}-${ind}`}>
                <Table.Cell
                  className={cn(classes.tableCell, row === 'r0' && classes.hov)}
                  onMouseEnter={mouseEnter}
                >
                  {company.createdDate &&
                  company.createdDate !== '-' &&
                  company.createdDate !== 'NA' ? (
                    <DateTime date={company.createdDate} time />
                  ) : (
                    'NA'
                  )}
                </Table.Cell>
                <Table.Cell
                  className={cn(classes.tableCell, row === 'r1' && classes.hov)}
                  onMouseEnter={mouseEnter}
                >
                  <ContactPerson
                    person={company.userCompanyEmail}
                    email={company.userCompanyEmail}
                    personClass={classes.fullName}
                  />
                </Table.Cell>
                <Table.Cell
                  className={cn(classes.tableCell, row === 'r2' && classes.hov)}
                  onMouseEnter={mouseEnter}
                >
                  {company.actionUserEmail}
                </Table.Cell>
                <Table.Cell
                  className={cn(classes.tableCell, row === 'r3' && classes.hov)}
                  onMouseEnter={mouseEnter}
                >
                  {company.activity}
                </Table.Cell>
                <Table.Cell
                  className={cn(classes.tableCell, row === 'r4' && classes.hov)}
                  onMouseEnter={mouseEnter}
                >
                  {company.activityType}
                </Table.Cell>
                <Table.Cell
                  className={cn(
                    classes.tableCell,
                    company.arrChanged &&
                      company.arrChanged !== '-' &&
                      company.arrChanged !== 'NA'
                      ? company.arrChanged < 0
                        ? classes.red
                        : classes.green
                      : '',
                    row === 'r5' && classes.hov
                  )}
                  onMouseEnter={mouseEnter}
                >
                  {moneyFormater(company.arrChanged)}
                </Table.Cell>
                <Table.Cell
                  className={cn(classes.tableCell, row === 'r6' && classes.hov)}
                  onMouseEnter={mouseEnter}
                >
                  {company.arrStatus}
                </Table.Cell>
                <Table.Cell
                  className={cn(classes.tableCell, row === 'r7' && classes.hov)}
                  onMouseEnter={mouseEnter}
                >
                  {company.lastUpdate &&
                  company.lastUpdate !== '-' &&
                  company.lastUpdate !== 'NA' ? (
                    <DateTime date={company.lastUpdate} time />
                  ) : (
                    'NA'
                  )}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        )}
      </Table>

      {loader ? <Loading /> : tableData.length === 0 && <EmptyState />}
    </>
  );
};

ArrActivityTable.propTypes = {
  tableData: PropTypes.arrayOf(object),
  direction: PropTypes.number,
  fieldName: PropTypes.string,
  handleSortable: PropTypes.func,
  loader: PropTypes.bool
};

export default ArrActivityTable;
